import { Action } from '@ngrx/store';
import { InventoryLookUpPost, SupplierItemLookUpPost } from 'src/app/shared/models/Inventory/InventoryLookUpEntity';
import { ReceivingList,
    SortKeyObject,
    SearchById,
    PurchaseModel,
    GetReceivingParamsDetaildById,
    PodetailModel,
    ReceivingPostModel
} from '../../models';

export enum EReceiving {
    GetReceiving = '[GetReceiving] Get GetReceiving',
    GetReceivingFilterById = '[GetReceivingFilterById] Get GetReceivingFilterById',
    GetReceivingSorting = '[GetReceivingSorting] Get GetReceivingSorting',
    GetReceivingSuccess = '[GetReceivingSuccess] Get GetReceivingSuccess',
    GetReceivingDetailById = '[GetReceivingDetailById] Get GetReceivingDetailById',
    GetReceivingDetailByIdSucess = '[GetReceivingDetailByIdSucess] Get GetReceivingDetailByIdSucess',
    GetReceivingSearch = '[GetReceivingSearch] Get GetReceivingSearch',
    GetReceivingViewModel = '[GetReceivingViewModel] Get GetReceivingViewModel',
    GetPoSearchbyId = '[GetPoSearchbyId] Get GetPoSearchbyId',
    GetPoSearchSuccess = '[GetPoSearchSuccess] Get GetPoSearchSuccess',
    GetLookupDetail = '[GetLookupDetail] Get GetLookupDetail',
    GetLookUpDetailSuccess = '[GetLookUpDetailSuccess] Get GetLookUpDetailSuccess',
    GetLookUpGridSuccess = '[GetLookUpGridSuccess] Get GetLookUpGridSuccess',
    GetItemList = '[GetItemList] Get GetItemList',
    GetSuppNumberItemList = '[GetSuppNumberItemList] Get GetSuppNumberItemList',
    GetItemListSuccess = '[GetItemListSuccess] Get GetItemListSuccess',
    GetSupplierItemNumberSuccess = '[GetSupplierItemNumberSuccess] Get GetSupplierItemNumberSuccess',
    GetItemPoSummary = '[GetItemPoSummary] Get GetItemPoSummary',
    GetItemPoSummarySuccess = '[GetItemPoSummarySuccess] Get GetItemPoSummarySuccess',
    GetSupplierList = '[GetSupplierList] Get GetSupplierList',
    GetSearchSupplier = '[GetSearchSupplier] Get GetSearchSupplier',
    GetSupplierSuccess = '[GetSupplierSuccess] Get GetSupplierSuccess',
    GetLocation = '[GetLocation] Get GetLocation',
    GetLocationSuccess = '[GetLocationSuccess] Get GetLocationSuccess',
    PostReceiving = '[PostReceiving] Get PostReceiving',
    PostReceivingSuccess = '[PostReceivingSuccess] Get PostReceivingSuccess',
    SaveReceiving = '[SaveReceiving] Get SaveReceiving',
    SaveReceivingSucess = '[SaveReceivingSucess] Get SaveReceivingSucess',
    ReceivingformDetails = '[ReceivingformDetails] Get ReceivingformDetails'
}

export class GetReceiving implements Action {
    readonly type = EReceiving.GetReceiving;
    constructor(public payload: any) { }
}

export class GetReceivingSuccess implements Action {
    readonly type = EReceiving.GetReceivingSuccess;
    constructor(public payload: any) { }
}

export class GetReceivingFilterById implements Action {
    readonly type = EReceiving.GetReceivingFilterById;
    constructor(public payload: number) { }
}

export class GetReceivingSorting implements Action {
    readonly type = EReceiving.GetReceivingSorting;
    constructor(public payload: SortKeyObject) { }
}
export class GetReceivingDetailById implements Action {
    readonly type = EReceiving.GetReceivingDetailById;
    constructor(public payload: GetReceivingParamsDetaildById) { }
}
export class GetReceivingDetailByIdSucess implements Action {
    readonly type = EReceiving.GetReceivingDetailByIdSucess;
    constructor(public payload: number) { }
}
export class GetReceivingSearch implements Action {
    readonly type = EReceiving.GetReceivingSearch;
    constructor(public payload: any) { }
}

export class GetReceivingViewModel implements Action {
    readonly type = EReceiving.GetReceivingViewModel;
    constructor(public payload: ReceivingList[]) { }
}

export class GetPoSearchbyId implements Action {
    readonly type = EReceiving.GetPoSearchbyId;
    constructor(public payload: SearchById) { }
}

export class GetPoSearchSuccess implements Action {
    readonly type = EReceiving.GetPoSearchSuccess;
    constructor(public payload: any) { }
}

export class GetLookupDetail implements Action {
    readonly type = EReceiving.GetLookupDetail;
    constructor(public payload: PodetailModel) { }
}
export class GetLookUpDetailSuccess implements Action {
    readonly type = EReceiving.GetLookUpDetailSuccess;
    constructor(public payload: any) { }
}

export class GetLookUpGridSuccess implements Action {
    readonly type = EReceiving.GetLookUpGridSuccess;
    constructor(public payload: PurchaseModel[]) { }
}

export class GetItemList implements Action {
    readonly type = EReceiving.GetItemList;
    constructor(public payload: InventoryLookUpPost) { }
}

export class GetSuppNumberItemList implements Action {
    readonly type = EReceiving.GetSuppNumberItemList;
    constructor(public payload: SupplierItemLookUpPost) { }
}

export class GetItemListSuccess implements Action {
    readonly type = EReceiving.GetItemListSuccess;
    constructor(public payload: any) { }
}

export class GetSupplierItemNumberSuccess implements Action {
    readonly type = EReceiving.GetSupplierItemNumberSuccess;
    constructor(public payload: any) {}
}

export class GetItemPoSummary implements Action {
    readonly type = EReceiving.GetItemPoSummary;
    constructor(public payload: any) { }
}

export class GetItemPoSummarySuccess implements Action {
    readonly type = EReceiving.GetItemPoSummarySuccess;
    constructor(public payload: any) { }
}

export class GetSupplierList implements Action {
    readonly type = EReceiving.GetSupplierList;
    constructor(public payload: any) { }
}
export class GetSearchSupplier implements Action {
    readonly type = EReceiving.GetSearchSupplier;
    constructor(public payload: any) { }
}
export class GetSupplierSuccess implements Action {
    readonly type = EReceiving.GetSupplierSuccess;
    constructor(public payload: any) { }
}

export class GetLocation implements Action {
    readonly type = EReceiving.GetLocation;
    constructor(public payload: any) { }
}

export class GetLocationSuccess implements Action {
    readonly type = EReceiving.GetLocationSuccess;
    constructor(public payload: any) { }
}
export class PostReceiving implements Action {
    readonly type = EReceiving.PostReceiving;
    constructor(public payload: ReceivingPostModel) { }
}

export class PostReceivingSuccess implements Action {
    readonly type = EReceiving.PostReceivingSuccess;
    constructor(public payload: any) { }
}

export class SaveReceiving implements Action {
    readonly type = EReceiving.SaveReceiving;
    constructor(public payload: ReceivingPostModel) { }
}

export class SaveReceivingSucess implements Action {
    readonly type = EReceiving.SaveReceivingSucess;
    constructor(public payload: any) { }
}

export class ReceivingformDetails implements Action {
    readonly type = EReceiving.ReceivingformDetails;
    constructor(public payload: any) { }
}


export type ReceivingAction =
GetReceiving |
GetReceivingSuccess |
GetReceivingFilterById |
GetReceivingSorting |
GetReceivingDetailById |
GetReceivingDetailByIdSucess|
GetReceivingSearch |
GetReceivingViewModel |
GetPoSearchbyId |
GetPoSearchSuccess |
GetLookupDetail |
GetLookUpDetailSuccess |
GetLookUpGridSuccess |
GetItemList |
GetItemListSuccess |
GetSupplierItemNumberSuccess |
GetItemPoSummary |
GetItemPoSummarySuccess |
GetSupplierList |
GetSearchSupplier |
GetSupplierSuccess |
GetLocation |
GetLocationSuccess |
PostReceiving |
PostReceivingSuccess |
SaveReceiving |
SaveReceivingSucess |
ReceivingformDetails;